
export const daysOfTheWeek = (type) => {
    let days;

    switch (type) {
        case 'ddd':
            days = [
                'S<span>un</span>',
                'M<span>on</span>',
                'T<span>ue</span>',
                'W<span>ed</span>',
                'T<span>hu</span>',
                'F<span>ri</span>',
                'S<span>at</span>',
            ];
            break;
        case 'dd':
            days = [
                'Su',
                'M',
                'Tu',
                'W',
                'Th',
                'F',
                'Sa',
            ];
            break;
        case 'd':
            days = [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S',
            ];
            break;
        default:
            days = [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
            ];
            break;
    }

    return days;

}